import { render, staticRenderFns } from "./DownloadPageSoft.vue?vue&type=template&id=477e6a88&scoped=true&"
import script from "./DownloadPageSoft.vue?vue&type=script&lang=js&"
export * from "./DownloadPageSoft.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPageSoft.vue?vue&type=style&index=0&id=477e6a88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e6a88",
  null
  
)

export default component.exports